import {PayloadAction, createSlice} from '@reduxjs/toolkit';

export type TabScreen = 'Home' | 'Transactions' | 'Bracelet' | 'Tips' | 'Profile';

type TabState = {
  screen: TabScreen;
};

const initialState: TabState = {
  screen: 'Home',
};

export const tabSlice = createSlice({
  name: 'tab',
  initialState,
  reducers: {
    setScreen: (state, action: PayloadAction<TabScreen>) => {
      state.screen = action.payload;
    },
  },
});

export const {setScreen} = tabSlice.actions;
